// extracted by mini-css-extract-plugin
export default {"TagBoxBackgroundClass":"TagBoxBackgroundClass_Rx4XK","dropdownRender":"dropdownRender__wndC","TagBoxOptions":"TagBoxOptions_hJcXh"};